// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ClickSlider_sliderContainer__HyXOA","slide":"ClickSlider_slide__TMLLi","image":"ClickSlider_image__wooik","text":"ClickSlider_text__q8NGI"};